export default __webpack_public_path__ + "static/media/google_play_badge.ce915fc3.png";